<div class="detail-backdrop" (click)="close()">
  <div
    class="detail-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="section.sectionNumber + ' ' + section.sectionTitle"
    (click)="$event.stopPropagation()"
  >
    <div class="detail-header">
      <h2 class="detail-title">
        {{ section.sectionNumber }} · {{ section.sectionTitle }} —
        {{ labels.REVIEW_REFINE.CHANGE_DETAIL.TITLE_SUFFIX }}
      </h2>
      <button
        type="button"
        class="close-btn"
        [attr.aria-label]="labels.REVIEW_REFINE.CHANGE_DETAIL.CLOSE_ARIA"
        (click)="close()"
      >
        &times;
      </button>
    </div>

    <div class="detail-body">
      <div class="pane-pair">
        <!-- Left pane: current version -->
        <section class="pane">
          <header class="pane-head">
            <span class="pane-label">
              {{ labels.REVIEW_REFINE.PREVIEW_CURRENT }}
            </span>
          </header>
          @if (currentPdf(); as pdf) {
            <ng2-pdfjs-viewer
              class="pane-pdf"
              [pdfSrc]="pdf"
              [theme]="'auto'"
              [download]="false"
              [urlValidation]="false"
              [showOpenFile]="false"
              [showSidebar]="false"
              [showSecondaryToolbarToggle]="false"
              [showToolbarLeft]="false"
              [zoom]="'page-width'"
              [customCSS]="'#toolbarViewerMiddle { position: absolute !important; left: 50% !important; transform: translateX(-50%) !important; } #scaleSelectContainer { display: flex !important; }'"
            >
            </ng2-pdfjs-viewer>
          } @else if (isCurrentLoading()) {
            <p class="pane-note pane-note-quiet">
              {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_LOADING }}
            </p>
          } @else {
            <div class="pane-note">
              <mat-icon class="pane-note-icon">picture_as_pdf</mat-icon>
              <span class="pane-note-text">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_UNAVAILABLE }}
              </span>
              <button type="button" class="aecom_btn pane-note-retry" (click)="loadCurrentPane()">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.RETRY }}
              </button>
            </div>
          }
        </section>

        <!-- Right pane: every proposed edit applied -->
        <section class="pane pane-new">
          <header class="pane-head">
            <span class="pane-label">
              {{ labels.REVIEW_REFINE.PREVIEW_NEW }}
            </span>
            <button
              type="button"
              class="pane-toggle"
              [disabled]="isRefreshing()"
              [title]="labels.REVIEW_REFINE.CHANGE_DETAIL.REFRESH_PREVIEW"
              (click)="refreshPreview()"
            >
              <mat-icon class="pane-caret">refresh</mat-icon>
              {{
                isRefreshing()
                  ? labels.REVIEW_REFINE.CHANGE_DETAIL.REFRESHING
                  : labels.REVIEW_REFINE.CHANGE_DETAIL.REFRESH_PREVIEW
              }}
            </button>
          </header>
          @if (updatedPdf(); as pdf) {
            <ng2-pdfjs-viewer
              class="pane-pdf"
              [pdfSrc]="pdf"
              [theme]="'auto'"
              [download]="false"
              [urlValidation]="false"
              [showOpenFile]="false"
              [showSidebar]="false"
              [showSecondaryToolbarToggle]="false"
              [showToolbarLeft]="false"
              [zoom]="'page-width'"
              [customCSS]="'#toolbarViewerMiddle { position: absolute !important; left: 50% !important; transform: translateX(-50%) !important; } #scaleSelectContainer { display: flex !important; }'"
            >
            </ng2-pdfjs-viewer>
          } @else if (isUpdatedLoading() || isRefreshing()) {
            <p class="pane-note pane-note-quiet">
              {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_LOADING }}
            </p>
          } @else if (updatedFailed()) {
            <div class="pane-note">
              <mat-icon class="pane-note-icon">picture_as_pdf</mat-icon>
              <span class="pane-note-text">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_UNAVAILABLE }}
              </span>
              <button type="button" class="aecom_btn pane-note-retry" (click)="refreshPreview()">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.RETRY }}
              </button>
            </div>
          } @else {
            <!-- Nothing requested yet: generating is on demand, not on open. -->
            <div class="pane-note">
              <mat-icon class="pane-note-icon">picture_as_pdf</mat-icon>
              <span class="pane-note-text">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_NOT_GENERATED }}
              </span>
              <button type="button" class="aecom_btn pane-note-retry" (click)="refreshPreview()">
                {{ labels.REVIEW_REFINE.CHANGE_DETAIL.REFRESH_PREVIEW }}
              </button>
            </div>
          }
        </section>
      </div>

      <div class="changes-scroll">
      @if (isSectionEditLoading()) {
        <div class="change-summary">
          <span class="change-type">{{ labels.REVIEW_REFINE.BUTTON.EDIT_SECTION }}</span>
          <p class="pane-note pane-note-quiet">
            {{ labels.REVIEW_REFINE.CHANGE_DETAIL.PREVIEW_LOADING }}
          </p>
        </div>
      } @else if (isSectionEditing()) {
        <!-- Whole-section rewrite, for a section opened with nothing proposed (US-14-01). -->
        <div class="change-summary">
          <span class="change-type">{{ labels.REVIEW_REFINE.BUTTON.EDIT_SECTION }}</span>
          <textarea
            rows="10"
            class="edit-input"
            [(ngModel)]="sectionDraft"
            [placeholder]="labels.REVIEW_REFINE.SECTION_EDIT_PLACEHOLDER"
          ></textarea>
        </div>

        <div class="detail-decisions">
          <button type="button" class="aecom_btn" (click)="cancelSectionEdit()">
            {{ labels.REVIEW_REFINE.BUTTON.CANCEL }}
          </button>
          <button
            type="button"
            class="aecom_btn--solid"
            [disabled]="!sectionDraft.trim()"
            (click)="saveSectionDraft()"
          >
            {{ labels.REVIEW_REFINE.BUTTON.SAVE }}
          </button>
        </div>
      } @else {
        <!-- Every proposed edit in the section, each decided on its own. -->
        @for (change of proposedChanges(); track change.id) {
          <div class="change-summary" [class.is-editing]="isEditing(change)">
            <div class="change-main">
              <div class="summary-head">
                <span class="change-type">{{ change.changeType }}</span>
                <span class="pill pill-status" [ngClass]="'status-' + change.status">
                  {{ change.status }}
                </span>
              </div>

              @if (isEditing(change)) {
                @if (isEdited(change)) {
                  <div class="change-provenance">
                    <p class="provenance-label"><strong>{{ labels.REVIEW_REFINE.SOURCE }}</strong>: Manual edit</p>
                    <p class="provenance-item"><em>Manually edited.</em></p>
                  </div>
                } @else if (showProvenance && sourceLine(change)) {
                  <div class="change-provenance">
                    <p class="provenance-label"><strong>{{ labels.REVIEW_REFINE.SOURCE }}</strong>: {{ sourceLine(change) }}</p>
                  </div>
                }
                @if (!isEdited(change) && rationaleLine(change)) {
                  <div class="change-provenance">
                    <p class="provenance-item"><em>{{ rationaleLine(change) }}</em></p>
                  </div>
                }
              }

              @if (isEditing(change)) {
                <div class="edit-block">
                  <label class="edit-label" [attr.for]="'edit-' + change.id">
                    {{ labels.REVIEW_REFINE.CHANGE_DETAIL.REPLACEMENT_TEXT }}
                  </label>
                  <textarea
                    rows="3"
                    class="edit-input"
                    [id]="'edit-' + change.id"
                    [(ngModel)]="editDraft"
                    [placeholder]="labels.REVIEW_REFINE.EDIT_PLACEHOLDER"
                  ></textarea>
                  @if (originalPhrase(change)) {
                    <p class="edit-hint">
                      "{{ originalPhrase(change) }}"
                      {{ labels.REVIEW_REFINE.CHANGE_DETAIL.REPLACE_HINT }}
                    </p>
                  }
                </div>
              } @else {
                <p class="change-diff">
                  @if (change.originalText || change.originalHtml) {
                    <span class="diff-old">{{ change.originalText ?? change.originalHtml }}</span>
                  }
                  <mat-icon class="diff-arrow">east</mat-icon>
                  @if (needsValue(change)) {
                    <span class="diff-new is-empty">
                      {{ labels.REVIEW_REFINE.NO_PROPOSED_VALUE }}
                    </span>
                  } @else {
                    <span class="diff-new">{{ effectiveValue(change) }}</span>
                  }
                </p>
              }
              @if (!isEditing(change) && isEdited(change)) {
                <div class="change-provenance">
                  <p class="provenance-label"><strong>{{ labels.REVIEW_REFINE.SOURCE }}</strong>: Manual edit</p>
                  <p class="provenance-item"><em>Manually edited.</em></p>
                </div>
              } @else if (!isEditing(change) && showProvenance && sourceLine(change)) {
                <div class="change-provenance">
                  <p class="provenance-label"><strong>{{ labels.REVIEW_REFINE.SOURCE }}</strong>: {{ sourceLine(change) }}</p>
                </div>
              }
              @if (!isEditing(change) && !isEdited(change) && rationaleLine(change)) {
                <div class="change-provenance">
                  <p class="provenance-item"><em>{{ rationaleLine(change) }}</em></p>
                </div>
              }
            </div>

            <div class="change-decisions">
              @if (!isDecided(change) && !isEditing(change)) {
                <button
                  type="button"
                  class="aecom_btn--solid btn-icon-only"
                  [disabled]="needsValue(change) || isAccepting(change)"
                  [title]="labels.REVIEW_REFINE.CHANGE_DETAIL.ACCEPT_CHANGE"
                  [attr.aria-busy]="isAccepting(change)"
                  [attr.aria-label]="labels.REVIEW_REFINE.CHANGE_DETAIL.ACCEPT_CHANGE"
                  (click)="onConfirm(change)"
                >
                  @if (isAccepting(change)) {
                    <span class="btn-progress" aria-hidden="true">
                      <span class="btn-spinner"></span>
                    </span>
                  } @else {
                    <mat-icon>check</mat-icon>
                  }
                </button>
              }
              @if (isEditing(change)) {
                <button
                  type="button"
                  class="aecom_btn"
                  (click)="cancelEdit()"
                >
                  {{ labels.REVIEW_REFINE.BUTTON.CANCEL }}
                </button>
                <button
                  type="button"
                  class="aecom_btn--solid"
                  [disabled]="!editDraft.trim()"
                  (click)="saveDraft(change)"
                >
                  {{ labels.REVIEW_REFINE.CHANGE_DETAIL.SAVE_EDIT }}
                </button>
              } @else {
                <button
                  type="button"
                  class="aecom_btn btn-icon-only btn-edit"
                  [title]="labels.REVIEW_REFINE.CHANGE_DETAIL.EDIT_TEXT"
                  [attr.aria-label]="labels.REVIEW_REFINE.CHANGE_DETAIL.EDIT_TEXT"
                  (click)="startEdit(change)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (!isDecided(change) && !isEditing(change)) {
                <button
                  type="button"
                  class="aecom_btn btn-icon-only btn-decline"
                  [title]="labels.REVIEW_REFINE.BUTTON.DECLINE"
                  [attr.aria-label]="labels.REVIEW_REFINE.BUTTON.DECLINE"
                  (click)="onDecline(change)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </div>
        } @empty {
          <p class="no-changes">{{ labels.REVIEW_REFINE.NO_CHANGES }}</p>
        }
      }
      </div>
    </div>
  </div>
</div>
